// removed by extract-text-webpack-plugin
module.exports = {"tab":"_1iuHIgFzFwMpty9IFlwGwa","active":"_2pmxa4PqOPmrKXVEE_5VhJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SimpleTab/SimpleTab.scss
// module id = 1315
// module chunks = 1